import React from 'react'
import { Dropdown, Menu, Divider, Container, Button, Grid, Header, List, Segment } from 'semantic-ui-react'
import { NavLink, BrowserRouter, Switch, Route } from 'react-router-dom'

import { CustomMessage, Navbar } from 'components'
import 'styling/semantic.less'
import * as styles from 'components/Navbar/NavbarChildren.less'

// Content
import About from './About'
import OpenClaw from './OpenClaw'
import OpenMM8 from './OpenMM8'


class App extends React.Component {
  state = { 
  }

  render() {
    return (
      <BrowserRouter>
        <div>
          <style>{'body { background-color: #efefef ; }'}</style>
          <style>{'mark { color: red ; background-color: transparent ; }'}</style>
          
          <Container className={styles.container}>
            <Menu fixed={top} size='huge' color='black' inverted>
              <Container>
                <Menu.Item as={NavLink} exact to="/" name="about" content='About me' icon='user circle outline' />
                {/*<Dropdown exact to="/projects" text='Projects'  item>
                  <Dropdown.Menu inverted>
                    <Dropdown.Item as={NavLink} exact to="/projects" name="projects" text='OpenClaw' />
                    <Dropdown.Item as={NavLink} exact to="/projectsss" name="projects" text='OpenMM8' />
                  </Dropdown.Menu>
                </Dropdown>*/}
                <Menu.Item as={NavLink} exact to="/OpenClaw" content='OpenClaw' icon='code' />
                <Menu.Item as={NavLink} exact to="/OpenMM8" content='OpenMM8' icon='code' />

                <Menu.Menu position='right'>
                  <Menu.Item as='a' content='Github' href='https://github.com/pjasicek' target='_blank' icon='github' />
                  <Menu.Item as='a' href='https://www.linkedin.com/in/petr-jasicek' target='_blank' icon='linkedin' />
                  <Menu.Item as='a' href='mailto:pjasicek@gmail.com' icon='mail' />
                </Menu.Menu>
              </Container>
            </Menu>  

            <Switch>
              <Route exact path='/' component={About} />
              <Route exact path='/OpenClaw' component={OpenClaw} />
              <Route exact path='/OpenMM8' component={OpenMM8} />
            </Switch>
          </Container>
        </div>
      </BrowserRouter>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js